// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"e0f87a73","595":"ce46008a","857":"fc696508"}[chunkId] + ".css";
};